export const getCsrfToken = () => {
  const tokenData = window.localStorage.getItem("csrf_token");
  if (!tokenData) return undefined;
  return JSON.parse(tokenData || {})?.token;
};

export const setCsrfToken = (tokenData) => {
  localStorage.setItem("csrf_token", JSON.stringify(tokenData));
};

export const setJwtTokenObject = (tokenData) => {
  localStorage.setItem("naut_jwt_token", JSON.stringify(tokenData));
}

export const getJwtTokenObject = () => {
  const token = window.localStorage.getItem("naut_jwt_token");
  if (!token) return undefined;

  try {
    const parsed = JSON.parse(token);

    // अगर token के अंदर access_token है (JWT string), तो उसे decode करें
    if (parsed?.access_token) {
      const base64Url = parsed.access_token.split(".")[1];
      if (!base64Url) return undefined;

      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(atob(base64));

      // expiry check
      const now = Math.floor(Date.now() / 1000); // current time in seconds
      if (payload.exp && payload.exp < now) {
        console.warn("JWT token expired");
        return undefined;
      }

      return parsed;
    }

    return parsed;
  } catch (e) {
    console.error("Failed to parse JWT token", e);
    return undefined;
  }
};
